import * as React from 'react';

import {Popover} from 'shells/popover/popover';
import {Select} from 'shells/select/select';

import styles from './step-delay-dialog.module.css';

type Props = {
    anchor: HTMLElement | null | undefined;
    stepId: string;
    applyText: string;
    onApply: (arg1: string) => void;
    onCancel: () => void;
};
type State = {
    isLoading: boolean;
    options: any[];
    value?: any;
};

export class StepDelayDialog extends React.Component<Props, State> {
    // @ts-expect-error
    delayRequest: JQueryXHR;

    static defaultProps = {
        applyText: 'Apply delay',
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            isLoading: false,
            options: [],
            value: undefined,
        };
    }

    componentDidMount() {
        this.delayRequest = $.ajax({
            type: 'GET',
            url: `/rest/steps/${this.props.stepId}/delays`,
        }).done(
            (json) => {
                this.setState({
                    options: json.delays,
                    value: json.delays[0],
                    isLoading: false,
                });
            },
            () => {
                this.setState({
                    isLoading: false,
                });
            }
        );
    }

    componentWillUnmount() {
        this.delayRequest.abort();
    }

    render() {
        return (
            <Popover anchor={this.props.anchor} isDialog={true} bodyColor='dark'>
                <h3 className={styles.header}>Delay this step?</h3>
                {this.state.isLoading ? (
                    <div>Loading delay options…</div>
                ) : (
                    <Select
                        // @ts-expect-error
                        label='Is this cool?'
                        value={this.state.value}
                        valueKey='id'
                        labelKey='name'
                        selectValues={this.state.options}
                        onChange={this.handleChange}
                    />
                )}
                <div className='buttons'>
                    <a href='#' className='ui-btn ui-btn--grey' onClick={this.props.onCancel}>
                        <span>Cancel</span>
                    </a>
                    <a href='#' className='ui-btn ui-btn--green' onClick={this.handleApply}>
                        <span>{this.props.applyText}</span>
                    </a>
                </div>
            </Popover>
        );
    }

    handleApply = () => {
        if (this.state.value) {
            this.props.onApply(this.state.value.id);
        }
    };

    handleChange = (val: any) => {
        this.setState({value: val});
    };
}
